export default "__VITE_ASSET__ce53c1a9__"